import {
    Component,
    ViewEncapsulation,
    ViewChild,
    ElementRef,
    OnInit,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProductStepsComponent } from '../../components/product-steps/product-steps.component';
import { AboutUsBusinessGrowComponent } from './components/about-us-business-grow/about-us-business-grow.component';
import { AboutUsBannerComponent } from './components/about-us-banner/about-us-banner.component';
import { AboutUsContentComponent } from './components/about-us-content/about-us-content.component';
import { AboutUsGuideComponent } from './components/about-us-guide/about-us-guide.component';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        HeaderComponent,
        FooterComponent,
        TranslateModule,
        RouterModule,
        CommonModule,
        ProductStepsComponent,
        AboutUsBusinessGrowComponent,
        AboutUsBannerComponent,
        AboutUsContentComponent,
        AboutUsGuideComponent,
    ],
    standalone: true,
})
export class AboutUsComponent implements OnInit {
    @ViewChild('financialAdvisoryImage') financialAdvisoryImage: ElementRef;

    clickedOutside: boolean = false;
    isAuthenticated: boolean = false;
    selectedLanguage: string;

    constructor() {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    ngOnInit() {
        this.selectedLanguage = localStorage.getItem('language') || 'en';
    }

    /* HEADER AREA */
    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    scrollToFinancialAdvisory() {
        if (this.financialAdvisoryImage) {
            this.financialAdvisoryImage.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }

    onClickEligibility() {
        window.location.href = '/business-financing';
    }
}
